<template>
  <div class="min-h-screen bg-gradient-to-br from-navy-50 via-white to-primary-50">
    <!-- Hero section -->
    <div class="relative overflow-hidden">
      <!-- Background pattern -->
      <div class="absolute inset-0 bg-gradient-to-r from-primary-600 via-primary-700 to-navy-800"></div>
      <div class="absolute inset-0 bg-black/10"></div>
      
      <!-- Decorative elements -->
      <div class="absolute top-0 left-0 w-full h-full">
        <div class="absolute top-20 left-10 w-32 h-32 bg-gold-400/20 rounded-full blur-3xl"></div>
        <div class="absolute bottom-20 right-10 w-40 h-40 bg-accent-400/20 rounded-full blur-3xl"></div>
        <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-white/10 rounded-full blur-3xl"></div>
      </div>
      
      <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div class="text-center animate-fade-in">
          <h1 class="hero-title text-white mb-6">
            Nos <span class="bg-gradient-to-r from-gold-400 to-gold-300 bg-clip-text text-transparent">Partenaires</span>
          </h1>
          <p class="hero-subtitle text-white/90 max-w-3xl mx-auto">
            Nous remercions nos partenaires qui nous soutiennent dans notre mission musicale
          </p>
        </div>
      </div>
    </div>
    
    <!-- Sponsors content -->
    <div class="py-16">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <!-- Gold Partners Section -->
        <div class="mb-16">
          <h2 class="text-3xl font-bold text-center text-gray-900">
            <span class="inline-flex items-center">
            </span>
          </h2>
          <PartnersLogos />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PartnersLogos from '../components/PartnersLogos.vue'

export default {
  name: 'Sponsors',
  components: {
    PartnersLogos
  }
}
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
